// removed by extract-text-webpack-plugin
module.exports = {"kep-login-facebook":"facebook__kep-login-facebook","small":"facebook__small","medium":"facebook__medium","metro":"facebook__metro","fa":"facebook__fa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FacebookLoginButton/FacebookLogin/facebook.scss
// module id = 1851
// module chunks = 0